exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".slide {\n  background-color: blueviolet;\n  border-radius: 20px;\n  float: left;\n  margin-right: 20px;\n  position: relative;\n  box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);\n  color: #ffffff;\n  background-position: center;\n  background-size: cover;\n  width: 100%;\n  cursor: pointer;\n}", ""]);

